import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { scrollMarginStyles } from '../../components/FloatingContainer/styles';
import { useElementBreakpoints } from '../../hooks/useElementBreakpoints';
import { buttonAutoFocusRingFix } from '../../styles/focus';
import messages from './messages';
import { buttonContainerStyles, getContainerStyles, getIconStyles, getTextContainerStyles, iconColor, textStyles } from './styles';
export var DiscardScreen = function DiscardScreen(_ref) {
  var onCancel = _ref.onCancel,
    onDiscard = _ref.onDiscard,
    text = _ref.text;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    containerElement = _useState2[0],
    setContainerElement = _useState2[1];
  var _useElementBreakpoint = useElementBreakpoints(),
    _useElementBreakpoint2 = _slicedToArray(_useElementBreakpoint, 2),
    setBreakpointsElement = _useElementBreakpoint2[0],
    breakpoint = _useElementBreakpoint2[1].breakpoint;
  var setRootContainer = function setRootContainer(element) {
    setContainerElement(element);
    setBreakpointsElement(element);
  };

  // Scroll the discard screen into view if it's not fully visible
  useEffect(function () {
    if (containerElement) {
      containerElement.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [containerElement]);
  return jsx(FloatingContainer, {
    ref: setRootContainer,
    "data-testid": "discard-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "discard-screen ".concat(AI_MODAL_SCREEN_CLASS)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: [getContainerStyles(breakpoint), scrollMarginStyles],
    paddingAdjustments: {
      top: 1,
      bottom: 1
    },
    rainbowBorder: !editorExperiment('platform_editor_ai_command_palette_post_ga', 'test')
  }, jsx(VisuallyHidden, null, formatMessage(messages.warningIconLabel)), jsx("div", {
    css: getTextContainerStyles(breakpoint)
  }, jsx("span", {
    css: getIconStyles(breakpoint)
  }, jsx(WarningIcon, {
    label: formatMessage(messages.warningIconLabel),
    primaryColor: iconColor
  })), jsx("p", {
    css: textStyles
  }, text)), jsx("div", {
    css: buttonContainerStyles
  }, jsx(Button, {
    testId: "cancel-button",
    spacing: "compact",
    onClick: onCancel,
    type: "button",
    appearance: "subtle"
  }, formatMessage(messages.cancelLabel)), jsx(Button, {
    autoFocus: true
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: buttonAutoFocusRingFix,
    testId: "discard-button",
    spacing: "compact",
    onClick: onDiscard,
    type: "button",
    appearance: "warning"
  }, formatMessage(messages.discardLabel))));
};